
function common_utils()
{

}

common_utils.readDataValue = function(obj,data,isReadReId = false,isEndTime= false)
{
    // if(isReadReId)
    // {
    //     obj.recordId = data.recordId;
    // }
    obj.recordId = data.recordId;
    obj.username = data.loginName;
    obj.gameid = data.gameId;
    obj.bet = data.bet;
    obj.win = data.win;
    obj.profit = data.win - data.bet
    obj.betamount = data.bet;
    obj.startTime = data.startTime;
    obj.endTime = data.endTime

}

common_utils.roundToFixed =  function(num,fractionDigits)
{

  console.log("roundToFixed")
  if(fractionDigits === undefined || fractionDigits < 0){
    fractionDigits = 2;
  }
  if(common_utils.isNull(num))
  {
    return "0";
  }
  //return  num.toFixed(fractionDigits);
  let result = num.toFixed(fractionDigits);
  let searchString = "";
  if(fractionDigits>0)
  {
    searchString = "."
    for (let i = 0; i < fractionDigits; i++) {
        searchString +="0"
    }
  }
  if (result.endsWith(searchString)) {
    return result.substring(0, result.length - (fractionDigits+1));
  }
  return result;
}



common_utils.isFreeTip = function (data,obj= null)
{
  if(obj !=null)
  {
    return data.isFree === 1 ?obj.$t('lang.str_t'):obj.$t('lang.str_f');
  }
  else
  {
    return data.isFree === 1 ?'是':'否';
  }
}

common_utils.isExtTip = function (data,obj = null)
{
  return data.ext === 1 ?'是':'否';
}

common_utils.isFree = function (data)
{
  if(data)
  {
    if(data.hasOwnProperty("isFree"))
    {
      return data.isFree === 1;
    }
  }
  return false;
}


common_utils.isExt = function (data,obj = null)
{
  if(data)
  {
    if(data.hasOwnProperty("ext"))
    {
      return data.ext === 1;
    }
    if(data.hasOwnProperty("exBet")){
      return data.exBet === 1;
    }

  }
  return false;
}


common_utils.isNull = function (obj){
  return obj === null || obj === undefined;

}

common_utils.getValue = function (obj,key){
  if(!common_utils.isNull(obj))
  {
    if(obj.hasOwnProperty(key))
    {
       return obj[key];
    }
  }
  return 0;
}

common_utils.getValueToFixed = function (obj,key){
  if(!common_utils.isNull(obj))
  {
    if(obj.hasOwnProperty(key))
    {
      let  value =  obj[key];
      return common_utils.getValueFixed(value);
    }
  }
  return 0;
}

common_utils.getValueFixed = function (value)
{
  if(common_utils.isNumber(value))
  {
    return (value / 100).toFixed(2)
  }
  return 0;
}




common_utils.isNumber =  function(value) {
  return typeof value === 'number';
}


common_utils.objToArray = function (obj){
  return Object.keys(obj).map(function(key) {
    return obj[key];
  });
}


export {
  common_utils
};



// WEBPACK FOOTER //
// ./src/components/common/common_utils.js